import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import CancelButton from '../../assets/images/CancelButton.svg'
import { Button, IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useCallback, useState } from 'react'
import CancelAccountPlanDlg from '../CancelAccountPlanDlg'
import { type SelectChangeEvent } from '@mui/material/Select'
import { useGetSubscriptionMutation } from '../../redux/api/userApi'
import Btn from '../Btn'
import useToken from '../../hooks/useToken'
import { openZoomWidget } from '../../utils/openZoomWidget'
import { useSelector } from 'react-redux'
import {
  outputTextAdvertising,
  outputTextContent,
  outputTextLocalPresence,
  outputTextWebsite,
  outputTextDesignStudio,
  reasons,
  ServiceAdvertisingText,
  ServiceContentText,
  ServiceDesignStudioText,
  ServiceLocalPresenceText,
  ServiceWebsiteText
} from './serviceFlowConfig'
import CancelModalStepOne from './CancelModalStepOne'

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 592,
  bgcolor: 'background.paper',
  borderRadius: '15px',
  boxShadow: 24,
  p: '40px 40px 48px 40px'
}

const ModalButton = styled(Button)({
  '&:hover': {
    backgroundColor: '#09B5EC'
  }
})

export const ModalState = {
  stepOne: 'stepOne',
  stepTwo: 'stepTwo',
  stepThree: 'stepThree',
  stepFour: 'stepFour'
}

export default function CancelModal ({ open, handleOpen, productInfo, category, isLoading, isSuccess, deleteSubscription }: { open: boolean, handleOpen: any, productInfo: any, category: any, isLoading: boolean, isSuccess: boolean, deleteSubscription: any }) {
  const IHF = useSelector((state: any) => state.ihfState)
  const { leads } = IHF
  const { xsrf } = useToken()
  const [getSubscriptions, { isLoading: isLoadingSubsctiption }] = useGetSubscriptionMutation()
  const [mode, setMode] = useState(ModalState.stepOne)
  const [textStepThree, setTextStepThree] = useState('')
  const [cancelPlanReason, setCancelPlanReason] = React.useState('')
  const handleMode = (step: React.SetStateAction<string>) => { setMode(step) }
  const handleModeThree = (step: React.SetStateAction<string>) => { setMode(ModalState.stepThree) }

  const numberOfLeads: number = leads?.length
  const productName: string = productInfo?.name
  const ServiceWebsite = (category === 'website')
  const ServiceContent = (category === 'content')
  const ServiceLP = (category === 'local_presence')
  const ServiceAds = (category === 'advertising')
  const ServiceDesignStudio = (category === 'design_studio')

  const handleTypeChange = useCallback((event: SelectChangeEvent) => {
    if (ServiceWebsite) {
      setTextStepThree(outputTextWebsite[event.target.value])
    } else if (ServiceContent) {
      setTextStepThree(outputTextContent[event.target.value])
    } else if (ServiceLP) {
      setTextStepThree(outputTextLocalPresence[event.target.value])
    } else if (ServiceAds) {
      setTextStepThree(outputTextAdvertising[event.target.value])
    } else if (ServiceDesignStudio) {
      setTextStepThree(outputTextDesignStudio[event.target.value].replace(/{Product_Title}/g, productName))
    }
    setCancelPlanReason(event.target.value)
  }, [cancelPlanReason, textStepThree, category])

  const handleClose = () => {
    setMode(ModalState.stepOne)
    setCancelPlanReason('')
    handleOpen()
  }
  const handleOpenZoomWidgets = () => {
    handleOpen()
    openZoomWidget()
  }
  const handleDelete = async () => {
    const reason = reasons[category].find((reason: any) => reason.value === Number(cancelPlanReason))
    await deleteSubscription({ priceId: productInfo.priceId, reason: reason?.label, token: xsrf })
    setCancelPlanReason('')
    await getSubscriptions()
    setMode(ModalState.stepOne)
    handleOpen()
  }
  return (
        <Box>
            <Modal
                open={open}
                onClose={handleOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: 512,
                      height: 40,
                      mb: '34px'
                    }}>
                        <Typography id="modal-modal-title" sx={{ fontSize: '16px' }}>
                            Cancel Plan
                        </Typography>
                        <IconButton onClick={handleClose}>
                          <Box component="img" src={CancelButton}/>
                        </IconButton>
                    </Box>
                    {
                        mode === ModalState.stepOne
                          ? (
                              ((ServiceWebsite) &&
                                  <CancelModalStepOne
                                      text={ServiceWebsiteText(numberOfLeads)}
                                      onClickDecline={handleOpenZoomWidgets}
                                      confirmBtn={"I don't want to be found online, cancel my website."}
                                      diclineBtn={'Book an appointment to give my website a face lift'}
                                      handleMode={handleMode}
                                  />
                              ) ||
                              ((ServiceContent) &&
                                  <CancelModalStepOne
                                      text={ServiceContentText(numberOfLeads)}
                                      onClickDecline={handleOpenZoomWidgets}
                                      confirmBtn={"I don't want to be the local expert. Cancel my Content Package"}
                                      diclineBtn={'Review all my Content pages'}
                                      handleMode={handleMode}
                                  />
                              ) ||
                              ((ServiceLP) &&
                                  <CancelModalStepOne
                                      text={ServiceLocalPresenceText(numberOfLeads)}
                                      confirmBtn={"I don't want to be found. Cancel Local Presence"}
                                      diclineBtn={'Take me to my Local Presence analytics.'}
                                      handleMode={handleMode}
                                      serviceCategory={ServiceLP}
                                  />
                              ) ||
                              ((ServiceAds) &&
                                  <CancelModalStepOne
                                      text={ServiceAdvertisingText(numberOfLeads)}
                                      onClickDecline={handleClose}
                                      confirmBtn={"I don't want leads. Cancel my Facebook Ads"}
                                      diclineBtn={'Go to all my Facebook Leads'}
                                      handleMode={handleMode}
                                  />
                              ) ||
                              ((ServiceDesignStudio) &&
                                  <CancelModalStepOne
                                      text={ServiceDesignStudioText(numberOfLeads)}
                                      confirmBtn={'I no longer want to create designs that make my brand stand out. Cancel my Design Studio'}
                                      diclineBtn={'Book a marketing appointment with my Client Success Team'}
                                      handleMode={handleMode}
                                      serviceCategory={ServiceDesignStudio}
                                  />
                              )
                            )
                          : null
                    }
                    {
                        mode === ModalState.stepTwo
                          ? (
                                <CancelAccountPlanDlg
                                    reasons={reasons[category]}
                                    open={open}
                                    handleClose={handleOpen}
                                    handleMode={handleModeThree}
                                    cancelPlanReason={cancelPlanReason}
                                    setCancelPlanReason={setCancelPlanReason}
                                    handleTypeChange={handleTypeChange}
                                    serviceName={productInfo.name}
                                    category={category}
                                />
                            )
                          : null
                    }
                    {
                        mode === ModalState.stepThree
                          ? (
                                <>
                                    {
                                        <Typography id="stepThree-description" sx={{ fontSize: '16px', fontWeight: 400, mb: '30px', textAlign: 'justify' }}>
                                            {textStepThree}
                                        </Typography>
                                    }
                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <ModalButton onClick={() => { handleMode(ModalState.stepFour) }} disableElevation sx={{ background: '#09B5EC', border: '2px solid #09B5EC', fontSize: '12px' }}>No thank you, continue</ModalButton>
                                    </Box>
                                </>
                            )
                          : null
                    }
                    {
                        mode === ModalState.stepFour
                          ? (
                                <>
                                  {
                                    productInfo.interval === 'month'
                                      ? (
                                        <Typography id="stepThree-description" sx={{ fontSize: '16px', fontWeight: 400, mb: '30px', textAlign: 'center' }}>
                                          Thank you for your recent loyalty with Agent Elite.<br/>
                                          <br/>
                                          We&apos;re always looking to get better and continue to do so.<br/>
                                          <br/>
                                          If you have any other challenges, please refer to our Knowledge Base or sign up for one of our upcoming Marketing Appointments.<br/>
                                          <br/>
                                          By cancelling today your {productName} will be active during the grace period.<br/>
                                          <br/>
                                          Thank you again and have a great day!
                                        </Typography>
                                        )
                                      : (
                                        <Typography id="stepThree-description" sx={{ fontSize: '16px', fontWeight: 400, width: 485, mb: '30px', textAlign: 'center' }}>
                                          Thank you for your recent loyalty with Agent Elite.<br/>
                                          <br/>
                                          We&apos;re always looking to get better and continue to do so.<br/>
                                          <br/>
                                          If you have any other challenges, please refer to our Knowledge Base or sign up for one of our upcoming Marketing Appointments.<br/>
                                          <br/>
                                          By cancelling today, your {productName} will be active and you will continue to be charged until the end of your contract.<br/>
                                          <br/>
                                          Alternatively you can pay the remainder of your balance (link to Stripe payment form) to stop your service immediately.<br/>
                                          <br/>
                                          Thank you again and have a great day!
                                        </Typography>
                                        )
                                  }
                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <Btn
                                            disabled={isLoading || isLoadingSubsctiption}
                                            onClick={async () => { await handleDelete() }}
                                            text={'Done'}
                                            variant= 'contained'
                                            color='secondary'
                                            disableElevation
                                        />
                                    </Box>
                                </>
                            )
                          : null
                    }
                </Box>
            </Modal>
        </Box>
  )
}
